import React from 'react';
import { bool, func, object, oneOf, shape, string } from 'prop-types';
import { get } from 'lodash';

import MenuItem from '@material-ui/core/MenuItem';

import CheckboxGroup from '../../../components/FormFields/CheckboxGroup';
import Select from '../../../components/FormFields/Select';
import {
    SENSOR_SOURCE_TYPES,
    SENSOR_SOURCING_OPTIONS
} from '../../../helpers/sensors';

const MultiSensorSelect = ({
    errors,
    onBlur,
    onChange,
    ruleTarget,
    touched,
    values
}) => {
    const options =
        get(
            SENSOR_SOURCING_OPTIONS,
            `${values.sourceType}.${ruleTarget}`,
            []
        )
            .map(sourceKey => ({
                key:   sourceKey,
                label: SENSOR_SOURCE_TYPES[sourceKey]
            }));
    const hideCheckboxes = !options.length;

    return (
        <>
            <Select
                errors={errors.multiSensorOption}
                label="Multi-Sensor Option"
                name="multiSensorOption"
                onBlur={onBlur}
                onChange={onChange}
                required
                touched={touched.multiSensorOption}
                value={values.multiSensorOption}
            >
                <MenuItem value="First">First Sensor Found</MenuItem>
                <MenuItem value="Max">Max Value of All Sensors</MenuItem>
                <MenuItem value="Min">Min Value of All Sensors</MenuItem>
                <MenuItem value="Average">Average Value of All Sensors</MenuItem>
            </Select>
            <CheckboxGroup
                errors={errors.sensorSourcing}
                hidden={hideCheckboxes}
                label="Sensor Sourcing"
                name="sensorSourcing"
                onBlur={onBlur}
                onChange={onChange}
                options={options}
                required
                touched={touched.sensorSourcing}
                value={values.sensorSourcing}
            />
        </>
    );
};

MultiSensorSelect.propTypes = {
    errors:   {},
    onBlur:   () => {},
    onChange: () => {},
    touched:  {},
    values:   {}
};

MultiSensorSelect.propTypes = {
    errors: shape({
        multiSensorOption: string,
        sensorSourcing:    string
    }),
    onBlur:     func,
    onChange:   func,
    ruleTarget: oneOf(['Equipment', 'System']).isRequired,
    touched:    shape({
        multiSensorOption: bool,
        sensorSourcing:    object
    }),
    values: shape({
        multiSensorOption: string,
        sensorSourcing:    object
    })
};

export default MultiSensorSelect;
